import React, { createContext, useContext } from 'react';

interface MSALInitContextType {
  msalInitialized: boolean;
}

const MSALInitContext = createContext<MSALInitContextType | undefined>(undefined);

export const MSALInitProvider: React.FC<{ msalInitialized: boolean; children: React.ReactNode }> = ({
  msalInitialized,
  children
}) => {
  return (
    <MSALInitContext.Provider value={{ msalInitialized }}>
      {children}
    </MSALInitContext.Provider>
  );
};

export const useMSALInit = () => {
  const context = useContext(MSALInitContext);
  if (context === undefined) {
    throw new Error('useMSALInit must be used within a MSALInitProvider');
  }
  return context;
};
